import { getState } from '~src/state';
import _ from 'lodash';
import { EDITOR_MODE_DEFAULT } from '~config/editorConstants';

export const setProfilePhotoToAllMagicFrames = async () => {
  const editorMode = getState('editorMode');
  const servizio = getState('selected.servizio');

  if (editorMode !== EDITOR_MODE_DEFAULT || !servizio) {
    return;
  }

  if (_.has(servizio, 'allegati_pointer.objectId', false)) {
    const objects = window.canvas.getObjects();
    for (const obj of objects) {
      if (obj.type === 'MagicFrame') {
        if (obj.getPersonSrc().includes(process.env.OFC_CDN_URL)) {
          if (obj.isLoading() === false) {
            await obj.updatePerson(servizio.allegati_pointer.allegato.url);
            obj.scalePersonToWidth(obj.width * obj.scaleX);
            obj.scalePersonToWidth(obj.width * obj.scaleX);
            window.canvas.renderAll();
          } else {
            obj.on('frame:init', async function () {
              await obj.updatePerson(servizio.allegati_pointer.allegato.url);
              obj.scalePersonToWidth(obj.width * obj.scaleX);
              obj.scalePersonToWidth(obj.width * obj.scaleX);
              window.canvas.renderAll();
            });
          }
        }
      }
    }
  }
};
